export const BASE_URL = 'http://45.249.111.188:84/api/Account/sendEmail';
export const TO_Email = 'info@adventusindia.com';
export const CC_Email = 'vikas@adventusindia.com';
export const Subject_Contact = 'Query from Contact Page of www.adventusindia.com';
export const Subject_Enquiry = 'Query from Enquiry Form of www.adventusindia.com';
export const Subject_ChannelPartner = 'Query for Channel Partner of www.adventusindia.com';